import { hashDataInBrowser } from "../../analytics/ga4-helper";
import { COOKIES, setCookie } from "../../helpers/cookie";
import PASentry from "../../util/pa-sentry";

const CUSTOMER_BROWSER_ID_EXPIRY_DAYS = 365;
export async function setCustomerBrowserId(customerBrowserId: string) {
  try {
    if (customerBrowserId) {
      // Set Customer Browser ID
      window.customerBrowserId = customerBrowserId;
      setCookie(COOKIES.CUSTOMER_BROWSER_ID, customerBrowserId, CUSTOMER_BROWSER_ID_EXPIRY_DAYS);
      const hashedExternalId = await hashDataInBrowser(customerBrowserId);
      setCookie(COOKIES.EXTERNAL_ID_SHA, hashedExternalId, CUSTOMER_BROWSER_ID_EXPIRY_DAYS);
    }
  } catch (err) {
    PASentry.logException(new Error("Failed to set customer browser id"), null, null);
  }
}
